type PageObject = {
  name: string
  description: string
}

type ImpactModulePages = {
  [key: string]: PageObject
}

export const PROCESSES_AND_DOCUMENTS_PAGES: ImpactModulePages = {
  DRAFTS: {
    name: 'Rascunhos',
    description: 'Gestão dos rascunhos',
  },
  GROUP_MODULE_PERMISSION: {
    name: 'Permissões de grupo',
    description: 'Gestão das permissões de grupos',
  },
  PUBLIC_AGENT_MODULE_PERMISSION: {
    name: 'Permissões de agentes',
    description: 'Gestão das permissões dos agentes',
  },
}
